import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import Select from "react-select";

import FormItem from "app/components/inputs/FormItem";
import { durationCustomStyles, DropdownIndicator } from "app/components/PaymentSelector";
import styles from "./styles.module.scss";
import CheckMark from "../../../../public/images/checkmark-green.png";

interface PayingAthleteSelectProps {
  selectedAthletes: any[];
  paymentEditable: boolean;
}

export default function PayingAthleteSelect({ selectedAthletes, paymentEditable }: PayingAthleteSelectProps) {
  const { control } = useFormContext();
  const { t } = useTranslation();

  const customSingleValue = ({ data }: any) => (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <img src={data.profilePicture} alt={data.fullName} style={{ width: 24, height: 24, borderRadius: '50%', marginRight: 8 }} />
      {data.fullName}
    </div>
  );

  const customOption = (props: any) => {
    const { data, innerRef, innerProps, isSelected } = props;
    return (
      <div ref={innerRef} {...innerProps} style={{ padding: 10, display: 'flex', alignItems: 'center' }}>
        <img src={data.profilePicture} alt={data.fullName} style={{ width: 24, height: 24, borderRadius: '50%', marginRight: 8 }} />
        {data.fullName}
        {isSelected && <img className={styles.checkboxImagePayment} src={CheckMark} alt="Checkmark" />}
      </div>
    );
  };

  return (
    <FormItem className={styles.input_field}>
      <Controller
        name="paying_athlete_id"
        control={control}
        shouldUnregister={true}
        rules={{ required: t("This field is required") }}
        render={({ field, fieldState }) => (
          <>
            <Select
              {...field}
              classNamePrefix="rs"
              value={selectedAthletes.find(a => a.id === field.value)}
              onChange={(option) => field.onChange(option?.id)}
              options={selectedAthletes}
              getOptionLabel={(a) => a.fullName}
              getOptionValue={(a) => a.id}
              isDisabled={!paymentEditable}
              styles={durationCustomStyles}
              placeholder={t("Select paying User")}
              components={{ SingleValue: customSingleValue, Option: customOption, IndicatorSeparator: () => null, DropdownIndicator }}
              menuPortalTarget={document.body}
              menuPlacement="auto"
            />
            {fieldState.error && <span className={styles.error}>{fieldState.error.message}</span>}
          </>
        )}
      />
    </FormItem>
  );
}
